// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* An empty node body, saying which kind of empty it is (#224).

   Fills the body slot rather than sitting at the top of it: the states this
   replaces rendered nothing at all, so anything less than the full box still
   reads as "the node is broken and something is missing". */
.a71YA_lE8p4IX3T3raK1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 100%;
    min-height: 60px;
    padding: 12px;
    text-align: center;
    box-sizing: border-box;
}

.juF4OyDAopdReNGgcrfN {
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-secondary);
}

.pr7xeRjHF7Il9v2Z6Wli {
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-muted);
    /* A node body can be narrow; wrapping beats clipping the instruction. */
    max-width: 26ch;
    line-height: 1.35;
}
`, "",{"version":3,"sources":["webpack://./src/components/nodes/NodeEmptyState.module.css"],"names":[],"mappings":"AAAA;;;;4DAI4D;AAC5D;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,wEAAwE;IACxE,eAAe;IACf,iBAAiB;AACrB","sourcesContent":["/* An empty node body, saying which kind of empty it is (#224).\n\n   Fills the body slot rather than sitting at the top of it: the states this\n   replaces rendered nothing at all, so anything less than the full box still\n   reads as \"the node is broken and something is missing\". */\n.root {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    height: 100%;\n    min-height: 60px;\n    padding: 12px;\n    text-align: center;\n    box-sizing: border-box;\n}\n\n.title {\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-secondary);\n}\n\n.hint {\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-muted);\n    /* A node body can be narrow; wrapping beats clipping the instruction. */\n    max-width: 26ch;\n    line-height: 1.35;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `a71YA_lE8p4IX3T3raK1`,
	"title": `juF4OyDAopdReNGgcrfN`,
	"hint": `pr7xeRjHF7Il9v2Z6Wli`
};
export default ___CSS_LOADER_EXPORT___;
